import { claim } from '../../../api/actions/VaultFunctions';

export const useVaultsTiles = (account: string, addyData: any, vaults: any[]) => {
  const highestBoost = vaults.reduce(
    (max: number, curr: any) => (curr.boost > max ? curr.boost : max),
    0,
  );
  const lockedAmount = addyData
    ? addyData.balanceOf_basic / 1e18 + addyData.userLocked_lockedStaking / 1e18
    : null;
  const unlockTimestamp = addyData ? addyData.endingTimestamp_basic * 1000 : null;

  const vaultsWithInvests = vaults.filter((vault: any) => vault.valueUserStaked > 0);
  const investedInVaults = vaultsWithInvests.reduce(
    (acc: number, curr: any) => acc + curr.valueUserStaked,
    0,
  );
  const pendingVaultsReward = vaults.reduce(
    (acc: number, vault: any) =>
      acc + (vault.pendingReward / 10 ** 18) * (vault.boost > 0 ? 1 + vault.boost : 1),
    0,
  );

  const collectRewards = () => {
    vaults
      .filter((vault: any) => vault.pendingReward > 0)
      .forEach((vault: any) => claim(account, vault.vaultAddress));
  };

  return {
    highestBoost,
    lockedAmount,
    unlockTimestamp,
    vaultsWithInvests,
    investedInVaults,
    pendingVaultsReward,
    collectRewards,
  };
};
